exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div-center[data-v-6d6e3c6c]{margin:0 auto}.vertical-alignment-helper[data-v-6d6e3c6c]{display:table;height:100%;width:100%;pointer-events:none}.vertical-align-center[data-v-6d6e3c6c]{display:table-cell;vertical-align:middle;pointer-events:none;width:80%;margin:auto}.modal-content[data-v-6d6e3c6c]{width:inherit;max-width:inherit;height:inherit;margin:0 auto;pointer-events:all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d6e3c6c","scoped":true,"hasInlineConfig":false}!./src/assets/css/custom.css
// module id = 76
// module chunks = 0